__turbopack_context__.v({
  "playIcon": "DqHK8G_playIcon",
});
